import { Button, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  addToCart,
  addToCartLocal,
  deleteCartItem,
  getCartItems,
  toggleSignUp,
  updateCart,
  updateCartLocal,
  getCartItemsLocal,
  deleteCartItemLocal,
  pushEvent
} from '../../../store/actions/user/User';
import { saveEventData } from "../../../utils/events-handler"
import PopOver from '../../Common/PopOver'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import LinesEllipsis from 'react-lines-ellipsis'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '200px'
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
    textAlign: 'left'
  },
  cover: {
    width: '100%',
  },
  controls: {
    display: 'flex',
    alignItems: 'left',
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  playIcon: {
    height: 38,
    width: 38,
  },
  itemCard: {
    display: 'flex',
    justifyContent: 'space-around',
    margin: '1rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    height: '200px',
    width: '400px',
    alignItems: 'center',
    flexDirection: 'row'
  },
  itemImage: {
    height: '100%',
    flex: '1',
    width: '100%'
  },
  itemTitle: {
    width: '90%',
    fontSize: '20px',
    fontWeight: 'bold',
    textAlign: 'left',
    paddingLeft: '10%',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginTop: '-21px',
  },
  itemDescription: {
    fontSize: '12px',
    textAlign: 'left',
    paddingTop: '0.25rem',
    overflow: 'hidden',
    paddingLeft: '10%',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    marginTop: '21px',
  },
  itemAction: {
    display: 'flex',
    paddingTop: '0.5rem',
    alignItems: 'center',
    paddingLeft: '10%'
  },
  price: {
    paddingRight: '5px',
    textAlign: 'left',
    fontWeight: 'bold'
  },
  priceOffer: {
    textAlign: 'left',
    fontSize: '10px',
    fontWeight: 'bold'
  },
  unavailableCart: {
    fontSize: '14px'
  },
  addToCart: {
    width: '75px',
    height: '30px',
    background: 'rgb(1, 160, 90)',
    border: '1px solid rgb(1, 160, 90)',
    color: '#fff',
    borderRadius: '15px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    userSelect: 'none',
    '&:hover': {
      background: 'rgb(1, 160, 90)',
    }
  },
  addToCartBtn: {
    width: '75px',
    height: '30px',
    background: 'rgb(1, 160, 90)',
    border: '1px solid rgb(1, 160, 90)',
    color: '#fff',
    borderRadius: '15px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: '0 5px',
    userSelect: 'none',
    '&:hover': {
      background: 'rgb(1, 160, 90)',
    }
  },
  qty: {
    color: 'white',
    fontSize: '12px'
  },
  ellipsisWidth: {
    width: '200px',
    [theme.breakpoints.down('sm')]: {
      width: '140px',
    }
  }
}));

const Item = ({
  id,
  image,
  title,
  description,
  vendorId,
  price,
  product,
  isMenu,
  auth,
  toggleSignUp,
  getCartItems,
  addToCart,
  updateCart,
  updateCartLocal,
  deleteCartItem,
  deleteCartItemLocal,
  addToCartLocal,
  cart,
  pushEvent,
  vendor,
  closed
}) => {
  const classes = useStyles();
  const [quantity, updateQuantity] = useState(0);
  const [variant, setVariant] = useState([]);
  const [open, setOpen] = useState(false)
  const [isUpdate, setIsUpdate] = useState(false)

  useEffect(() => {
    if (cart?.length) {
      if (isMenu) {
        const cartItem = cart?.find((item) => item.menuId === id);
        if (cartItem) {
          updateQuantity(cartItem.quantity);
        }
      } else {
        const cartItem = cart?.find((item) => item.productId === id);
        var quant = 0;
        if (cart) {
          for (var i = 0; i < cart.length; i++) {
            if (cart[i].productId === id) {
              quant += cart[i].quantity
            }
          }
        }
        if (cartItem) {
          updateQuantity(quant);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (cart?.length) {
      if (isMenu) {
        const cartItem = cart?.find((item) => item.menuId === id);
        if (cartItem) {
          updateQuantity(cartItem.quantity);
        }
      } else {
        const cartItem = cart?.find((item) => item.productId === id);
        var quant = 0;
        if (cart) {
          for (var i = 0; i < cart.length; i++) {
            if (cart[i].productId === id) {
              quant += cart[i].quantity
            }
          }
        }
        if (cartItem) {
          updateQuantity(quant);
        }
      }
    } else {
      updateQuantity(0);
    }
  }, [JSON.stringify(cart), cart?.length]);

  const removeFromCart = () => {
    if (auth) {
      if (isMenu) {
        const cartPayload = cart?.find((item) => item.menuId === id);
        if (quantity === 1) {
          deleteCartItem(cartPayload?.id).then((data) => {
            if (data) {
              getCartItems();
            }
          });
        } else {
          updateCart({ cartId: cartPayload.id, quantity: quantity - 1 }).then(
            (data) => {
              if (data) {
                getCartItems();
              }
            }
          );
        }
      } else {
        const cartPayload = cart?.find((item) => item.productId === id);
        if (quantity === 1) {
          deleteCartItem(cartPayload?.id).then((data) => {
            if (data) {
              getCartItems();
            }
          });
        } else {
          updateCart({ cartId: cartPayload.id, quantity: quantity - 1 }).then(
            (data) => {
              if (data) {
                getCartItems();
              }
            }
          );
        }
      }
    } else {
      const key = isMenu ? 'menuId' : 'productId'
      var cartPayload = cart?.find((item) => item[key] === id);
      if (quantity === 1 || cartPayload.quantity == 1) {
        deleteCartItemLocal(cartPayload, key);
      } else {
        cartPayload.quantity = quantity - 1
        updateCartLocal(cartPayload, key);
      }
      getCartItemsLocal();
    }
    updateQuantity(quantity - 1);
  };

  const handleClose = () => {
    setOpen(false)
  }

  const handleAddToCart = (variant) => {
    const payload = {
      vendorId: vendorId,
      quantityType: '1',
      quantity: 1,
      productId: '',
      menuId: '',
      variant: variant
    };
    proceedAddToCart(payload)
    setOpen(false)
  }

  const addCart = () => {
    if (product.variant && product.variant.length > 0 && product.variant[0].heading) {
      setVariant(product.variant)
      setOpen(true)
    } else {
      const payload = {
        vendorId: vendorId,
        quantityType: '1',
        quantity: 1,
        productId: '',
        menuId: ''
      };
      proceedAddToCart(payload)
    }
  };

  const proceedAddToCart = (payload) => {
    if (isMenu) {
      payload.menuId = id;
    } else {
      payload.productId = id;
    }
    saveEventData(pushEvent, product.name+"AddedToCart")
    if (auth) {
      addToCart(payload).then((data) => {
        if (data) {
          updateQuantity(quantity + 1);
          getCartItems();
        }
      });
    } else {
      payload.products = [product]
      addToCartLocal(payload, vendor);
      getCartItemsLocal();
      updateQuantity(quantity + 1);
    }
  }

  const updateToCart = () => {
    if (product.variant && product.variant.length > 0 && product.variant[0].heading) {
      setVariant(product.variant)
      setOpen(true)
      setIsUpdate(true)
    } else {
      if (auth) {
        if (isMenu) {
          const cartPayload = cart?.find((item) => item.menuId === id);
          if (cartPayload) {
            updateCart({ cartId: cartPayload.id, quantity: quantity + 1 }).then(
              (data) => {
                if (data) {
                  getCartItems();
                }
              }
            );
          }
        } else {
          const cartPayload = cart?.find((item) => item.productId === id);
          if (cartPayload) {
            updateCart({ cartId: cartPayload.id, quantity: quantity + 1 }).then(
              (data) => {
                if (data) {
                  getCartItems();
                }
              }
            );
          }
        }
      } else {
        const key = isMenu ? 'menuId' : 'productId'
        var cartPayload = cart?.find((item) => item[key] === id);
        cartPayload.quantity = quantity + 1
        updateCartLocal(cartPayload, key);
        getCartItemsLocal();
      }
      updateQuantity(quantity + 1);
    }
  };

  //   const updateLocalCart = () => {
  //     const tempCartItems = [...cart];
  //     const individualCart = tempCartItems?.findIndex((item) => {
  //       if (isMenu) {
  //         return item.menuId === id;
  //       } else {
  //         return item.productId === id;
  //       }
  //     });
  //     const cartPayload = {
  //       menuId: tempCartItems[individualCart]?.menuid || '',
  //       productId: tempCartItems[individualCart]?.productId || '',
  //       quantity: tempCartItems[individualCart].quantity + 1,
  //       products: []
  //     };
  //     if (individualCart !== -1) {
  //       cartPayload.products.push({ price: price });
  //       tempCartItems[individualCart] = cartPayload;
  //     } else {
  //       tempCartItems.push(cartPayload);
  //     }
  //     addToCartLocal(tempCartItems);
  //   };
  return (
    <>
      <Card className={classes.root}>
        <div className={classes.details}>
          <CardContent className={classes.content}>
            <LinesEllipsis
              className={classes.ellipsisWidth}
              style={{ fontSize: '15px', fontWeight: 'bold' }}
              text={title}
              title={title}
              maxLine='2'
              ellipsis='...'
              trimRight
              basedOn='letters'
            />
            <LinesEllipsis
              className={classes.ellipsisWidth}
              style={{ fontSize: '12px' }}
              text={description}
              title={description}
              maxLine='2'
              ellipsis='...'
              trimRight
              basedOn='letters'
            />
            {/* <Typography variant="p" component="p" style={{width:'170px', fontSize:'12px',display: '-webkit-box',
    '-webkit-line-clamp': 4,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden'}}>
              {description}
            </Typography> */}
          </CardContent>
          <CardContent className={classes.content}>
            <div>
              <div>
                <div className={classes.price} style={product.isOffer ? { paddingRight: '0px' } : {}}>{product.isOffer ? product.offerPrice : price} AUD</div>
                {product.isOffer && <del style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}><div className={classes.priceOffer}>{price} AUD</div></del>}
              </div>
              {product.quantity == 0 || closed ?

                <div className={classes.unavailableCart}>
                  {closed ? 'Closed' : 'Unavailable'}
                </div>
                :
                <div className={classes.addToCart} style={{ marginRight: '5%' }}>
                  {quantity === 0 ? (
                    <div className={classes.add} onClick={addCart}>
                      + ADD
                    </div>
                  ) : (
                      <>
                        <div className={classes.minus} onClick={removeFromCart}>
                          -
    </div>
                        <div className={classes.qty}>{quantity} Qty</div>
                        <div className={classes.plus} onClick={updateToCart}>
                          +
    </div>
                      </>
                    )}
                </div>
              }
            </div>
          </CardContent>
        </div>
        <CardMedia
          className={classes.cover}
          image={image}
          title={title}
        />
      </Card>
      <PopOver image={image} price={price} title={title} open={open} variant={variant} handleClose={handleClose} handleAddToCart={handleAddToCart}></PopOver>
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.user.auth,
  cart: state.user.cart
});

const mapDispatchToProps = (dispatch) => ({
  toggleSignUp: (isOpen) => dispatch(toggleSignUp(isOpen)),
  pushEvent: (details) => dispatch(pushEvent(details)),
  addToCart: (product) => dispatch(addToCart(product)),
  addToCartLocal: (product, vendor) => dispatch(addToCartLocal(product, vendor)),
  updateCart: (product) => dispatch(updateCart(product)),
  updateCartLocal: (product, key) => dispatch(updateCartLocal(product, key)),
  getCartItems: () => dispatch(getCartItems()),
  getCartItemsLocal: () => dispatch(getCartItemsLocal()),
  //   emptyCart: () => dispatch(emptyCart()),
  deleteCartItem: (cartId) => dispatch(deleteCartItem(cartId)),
  deleteCartItemLocal: (cartId, key) => dispatch(deleteCartItemLocal(cartId, key))
});

export default connect(mapStateToProps, mapDispatchToProps)(Item);
